import React from 'react';
import './App.css';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Navigation from './components/navigation';
import Projects from './components/projects';
import Git from './components/Git';
import Contacts from './components/contacts';
import Process from './components/process';
import HeroSection from './components/HeroSection';
import Footer from './components/footer';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';


  (function() {
      document.addEventListener('DOMContentLoaded', function(){
          let divs = document.querySelectorAll('.layer');
          [].forEach.call(divs, function(item) {

              let limit = 30,
                  star = [];

              while (limit) {
                  star = document.createElement('span');
                  star.classList.add('star');
                  star.innerHTML ='<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M10.744,5.372C7.777,5.372,5.372,2.967,5.372,0c0,2.967-2.405,5.372-5.372,5.372c2.967,0,5.372,2.405,5.372,5.372 C5.372,7.777,7.777,5.372,10.744,5.372z"/></svg>';
                  star.style.left = randomInt(1, 100) + '%';
                  star.style.top = randomInt(1, 100) + '%';
                  star.style.transform = 'scale(' + randomNum(0, 1) + ')';
                  star.style.opacity = randomNum(0.6, 1);
                  item.appendChild(star);
                  limit--;
              }
          });
      });

      function randomInt(min, max) {
          return Math.floor((Math.random() * max) + min);
      }

      function randomNum(min, max) {
          return Math.max((Math.random() * max), min).toFixed(1);
      }
  })();

    let openNav = () => {
        const sideNav = document.getElementById("sideNav");
        sideNav.style.cssText = "right: 0; transition: all 0.5s linear 0s; width: 100%";
    };

    let closeNav = () => {
        const sideNav = document.getElementById("sideNav");
        sideNav.style.cssText = "right: -100%; transition: all 0.5s linear 0s; width: unset;";
    };

function App() {
  return (
      <main>
          <BrowserRouter>
            <div className="mb-5 mb-lg-0">
                <Navigation close={closeNav} open={openNav} />
                <Switch>
                    <Route exact path='/' component={HeroSection} />
                    <Route path='/Projects' component={Projects} />
                    <Route path='/Git' component={Git} />
                    <Route path='/Contacts' component={Contacts} />
                    <Route path='/Process' component={Process} />
                </Switch>
                <Footer/>
            </div>
          </BrowserRouter>
        <div id="layers">
                <div className="layer layer-1"/>
                <div className="layer layer-2"/>
                <div className="layer layer-3"/>
                <div className="layer layer-4"/>
                <div className="layer layer-5"/>
            </div>
      </main>
  );
}

export default App;
